import { Box, ButtonLink, IconSearch, Stack, Text } from 'braid-design-system';

import CustomSvg from 'src/components/CustomSvg/CustomSvg';
import { getConfigValues } from 'src/config';
import FloatingStarSvg from 'src/images/floating-star.svg';

export const NoSavedSearches = () => (
  <Box paddingY="large" id="no-results-search-for-businesses">
    <Stack space="small" align="center">
      <CustomSvg svg={FloatingStarSvg} width={45} height={57} />

      <Text>Looks like you don&apos;t have any saved searches yet</Text>

      <Text>Let&apos;s get busy!</Text>

      <Box paddingTop="medium">
        <ButtonLink
          id="saved-searches-no-results-btn"
          href={`${getConfigValues().HEADER_SERVER_BASE}/businesses-for-sale`}
          icon={<IconSearch />}
          tone="formAccent"
        >
          Search for businesses
        </ButtonLink>
      </Box>
    </Stack>
  </Box>
);
